import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetGamerList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_GAMER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetGamerListAction({
                    list: data.data.list,
                    count: data.data.count
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetGamerList as SetGetGamerList
}